// extracted by mini-css-extract-plugin
export default {"container":"_1AB1f","option":"_3NRMl","activeOptionPrimary":"_1fjrO","activeOptionSecondary":"_1Bpw7","optionPrimary":"_3044D","optionSecondary":"_27uFR"};